var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasErrors)?_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"alert alert-danger border-left-danger",attrs:{"role":"alert"}},[_c('h5',{staticClass:"alert-heading"},[_vm._v("Errors")]),_c('ul',{staticClass:"m-0"},_vm._l((_vm.getErrors),function(error,idx){return _c('li',{key:idx},[_vm._v(" "+_vm._s(error)+" ")])}),0)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }